import { createReducer, on } from "@ngrx/store";
import { AuthState } from "../../core/models/auth";
import { loginSuccess, loginSuccessFirebase, logout } from "./auth.action";
import { initialState } from "./auth.state";

export const _authReducer = createReducer<AuthState> (
    initialState,
    on(loginSuccess, (state, { authResponse }) => ({
        ...state,
        authResponse,
        firebaseResponse: null
    })),

    on(loginSuccessFirebase, (state, { firebaseResponse }) => ({
        ...state,
        authResponse: null,
        firebaseResponse,
    })),

    on(logout, (state) => ({
        ...state,
        authResponse: null,
        firebaseResponse: null
    }))
);

export function authReducer(state: AuthState | undefined, action: any) {
    return _authReducer(state, action);
}